import { AnimationMetadataType, animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { ApiService } from 'src/app/Services/api.service';
import { ModalBaseComponent } from 'src/app/shared/modals/modal-base/modal-base.component';

@Component({
    selector: 'app-editlegacysigndisplayrule',
    templateUrl: './editlegacysigndisplayrule.component.html',
    styleUrls: ['./editlegacysigndisplayrule.component.scss'],
    animations: [
        trigger('leftpanelslide', [
            state('full', style({ width: '100%' })),
            state('half', style({ width: '50%' })),
            state('smallinit', style({ width: '50%' })),
            state('biginit', style({ width: '100%' })),
            transition('* => half', [
                query('@*', animateChild(), { optional: true }),
                animate('.3s ease-in-out')
            ]),
            transition('* => full', [
                query('@*', animateChild(), { optional: true }),
                animate('.3s ease-in-out')
            ]),
            transition('* => smallinit', [
                style({ width: '50%' }),
                query('@*', animateChild(), { optional: true })
            ]),
            transition('* => biginit', [
                style({ width: '100%' }),
                query('@*', animateChild(), { optional: true })
            ])
        ]),
        trigger('rightpanelslide', [
            transition(':enter', [
                style({ width: '0', opacity: '0' }),
                query('@*', animateChild(), { optional: true }),
                animate('.3s ease-in-out', style({ width: '50%' })),
                animate('.1s ease-in-out', style({ opacity: '1' }))
            ]),
            transition(':leave', [
                style({ width: '50%', opacity: '1' }),
                group([
                    query('@*', animateChild(), { optional: true }),
                    animate('.1s ease-in-out', style({ opacity: '0' })),
                    animate('.3s ease-in-out', style({ width: '0' }))
                ])
            ])
        ]),
        trigger('rightpaneldisplay', [
            transition(':enter', [
                style({ width: '0', opacity: '0' }),
                query('@*', animateChild(), { optional: true }),
                animate('.3s ease-in-out', style({ width: '50%' })),
                animate('.1s ease-in-out', style({ opacity: '1' }))
            ]),
            transition(':leave', [
                style({ width: '50%', opacity: '1' }),
                group([
                    query('@*', animateChild(), { optional: true }),
                    animate('.1s ease-in-out', style({ opacity: '0' })),
                    animate('.3s ease-in-out', style({ width: '0' }))
                ])
            ])
        ]),
        trigger('leftpaneldisplay', [
            state('full', style({ width: '100%' })),
            state('half', style({ width: '50%' })),
            state('smallinit', style({ width: '50%' })),
            state('biginit', style({ width: '100%' })),
            transition('* => half', [
                group([
                    query('@*', animateChild(), { optional: true }),
                    animate('.3s ease-in-out')
                ])
            ]),
            transition('* => full', [
                group([
                    query('@*', animateChild(), { optional: true }),
                    animate('.3s ease-in')
                ])
            ]),
            transition('* => smallinit', [
                style({ width: '50%' }),
                query('@*', animateChild(), { optional: true })
            ]),
            transition('* => biginit', [
                style({ width: '100%' }),
                query('@*', animateChild(), { optional: true })
            ])
        ]),
        trigger('conditionGroupPanel', [
            state('expanded', style({
                height: '*',
                opacity: 1,
                overflow: 'visible'
            })),
            state('collapsed', style({
                height: '0',
                opacity: 0,
                overflow: 'hidden',
                padding: '0'
            })),
            transition('expanded <=> collapsed', [
                animate('0.3s ease-in-out')
            ])
        ]),
    ],
    standalone: false
})

export class EditlegacysigndisplayruleComponent extends ModalBaseComponent<any, null> implements OnInit, AfterViewInit {
  Form !: UntypedFormGroup;
  TargetType !: string;
  ModelProperties: any = [];

  DataTypeClass: any = '';
  SecondDataTypeClass: any = '';
  DataTypeMap: Map<string, string> = new Map([
    ['88', 'fa fa-times'],
    ['89', 'fa fa-check'],
    ['160', 'fa fa-arrow-up'],
    ['161', 'fa fa-arrow-up-right'],
    ['162', 'fa fa-arrow-right'],
    ['163', 'fa fa-arrow-down-right'],
    ['164', 'fa fa-arrow-down'],
    ['165', 'fa fa-arrow-down-left'],
    ['166', 'fa fa-arrow-left'],
    ['167', 'fa fa-arrow-up-left'],
  ]);

  HalfWidth: boolean = false;
  FullPanel: boolean = false;
  DisablePanelAnim: boolean = true;
  isConditionGroupMinimized: boolean = false;

  constructor(private apiService: ApiService, private fb: FormBuilder) {
    super();
    setTimeout(() => {
      this.DisablePanelAnim = false;
    }, 500);
  }

  get conditionGroupForm(): FormGroup {
    return this.Form.get('ConditionGroup') as FormGroup;
  }

  private populateConditionGroup(conditionGroup: any) {
    if (!conditionGroup) return;

    const conditionsArray = this.Form.get('ConditionGroup.Conditions') as FormArray;
    const childGroupsArray = this.Form.get('ConditionGroup.ChildGroups') as FormArray;

    // Set basic properties
    this.Form.get('ConditionGroup')?.patchValue({
      Id: conditionGroup.Id,
      RequireAllConditions: conditionGroup.RequireAllConditions
    });

    // Clear existing arrays
    while (conditionsArray.length) {
      conditionsArray.removeAt(0);
    }
    while (childGroupsArray.length) {
      childGroupsArray.removeAt(0);
    }

    // Add conditions
    if (conditionGroup.Conditions) {
      conditionGroup.Conditions.forEach((condition: any) => {
        const conditionForm = this.fb.group({
          Id: [condition.Id],
          ClassName: [condition.ClassName],
          TargetThresholdProperty: [condition.TargetThresholdProperty],
          TargetThresholdOperator: [condition.TargetThresholdOperator],
          Value: [condition.Value],
          Time: [condition.Time],
          Operator: [condition.Operator],
          ActiveMonday: [condition.ActiveMonday],
          ActiveTuesday: [condition.ActiveTuesday],
          ActiveWednesday: [condition.ActiveWednesday],
          ActiveThursday: [condition.ActiveThursday],
          ActiveFriday: [condition.ActiveFriday],
          ActiveSaturday: [condition.ActiveSaturday],
          ActiveSunday: [condition.ActiveSunday]
        });
        conditionsArray.push(conditionForm);
      });
    }

    // Add child groups recursively
    if (conditionGroup.ChildGroups && conditionGroup.ChildGroups.length > 0) {
      conditionGroup.ChildGroups.forEach((childGroup: any) => {
        const childGroupForm = this.fb.group({
          Id: [childGroup.Id],
          RequireAllConditions: [childGroup.RequireAllConditions],
          Conditions: this.fb.array([]),
          ChildGroups: this.fb.array([])
        });
        childGroupsArray.push(childGroupForm);
        
        // Populate conditions for this child group
        const childConditionsArray = childGroupForm.get('Conditions') as FormArray;
        if (childGroup.Conditions) {
          childGroup.Conditions.forEach((condition: any) => {
            const conditionForm = this.fb.group({
              Id: [condition.Id],
              ClassName: [condition.ClassName],
              TargetThresholdProperty: [condition.TargetThresholdProperty],
              TargetThresholdOperator: [condition.TargetThresholdOperator],
              Value: [condition.Value],
              Time: [condition.Time],
              Operator: [condition.Operator],
              ActiveMonday: [condition.ActiveMonday],
              ActiveTuesday: [condition.ActiveTuesday],
              ActiveWednesday: [condition.ActiveWednesday],
              ActiveThursday: [condition.ActiveThursday],
              ActiveFriday: [condition.ActiveFriday],
              ActiveSaturday: [condition.ActiveSaturday],
              ActiveSunday: [condition.ActiveSunday]
            });
            childConditionsArray.push(conditionForm);
          });
        }
        
        // Recursively populate child groups of this child group
        this.populateChildGroups(childGroup, childGroupForm);
      });
    }
  }
  
  // Helper method to recursively populate nested child groups
  private populateChildGroups(group: any, formGroup: FormGroup) {
    if (!group.ChildGroups || group.ChildGroups.length === 0) return;
    
    const childGroupsArray = formGroup.get('ChildGroups') as FormArray;
    
    group.ChildGroups.forEach((childGroup: any) => {
      const childGroupForm = this.fb.group({
        Id: [childGroup.Id],
        RequireAllConditions: [childGroup.RequireAllConditions],
        Conditions: this.fb.array([]),
        ChildGroups: this.fb.array([])
      });
      childGroupsArray.push(childGroupForm);
      
      // Populate conditions for this child group
      const childConditionsArray = childGroupForm.get('Conditions') as FormArray;
      if (childGroup.Conditions) {
        childGroup.Conditions.forEach((condition: any) => {
          const conditionForm = this.fb.group({
            Id: [condition.Id],
            ClassName: [condition.ClassName],
            TargetThresholdProperty: [condition.TargetThresholdProperty],
            TargetThresholdOperator: [condition.TargetThresholdOperator],
            Value: [condition.Value],
            Time: [condition.Time],
            Operator: [condition.Operator],
            ActiveMonday: [condition.ActiveMonday],
            ActiveTuesday: [condition.ActiveTuesday],
            ActiveWednesday: [condition.ActiveWednesday],
            ActiveThursday: [condition.ActiveThursday],
            ActiveFriday: [condition.ActiveFriday],
            ActiveSaturday: [condition.ActiveSaturday],
            ActiveSunday: [condition.ActiveSunday]
          });
          childConditionsArray.push(conditionForm);
        });
      }
      
      // Recursively populate child groups of this child group
      this.populateChildGroups(childGroup, childGroupForm);
    });
  }

  ngOnInit(): void {
    // Initialize conditionGroup if it doesn't exist
    if (!this.Form.contains('ConditionGroup')) {
      this.Form.addControl('ConditionGroup', this.fb.group({
        Id: [null],
        RequireAllConditions: [false],
        Conditions: this.fb.array([]),
        ChildGroups: this.fb.array([])
      }));
    }

    // Populate condition group if data exists
    if (this.Form.value.ConditionGroup) {
      this.populateConditionGroup(this.Form.value.ConditionGroup);
    }

    // Fetch model properties for the target type
    if (this.TargetType) {
      this.apiService.Get("common/modeltypes/" + this.TargetType + "/properties").then(result => {
        this.ModelProperties = result;
      });
    }

    var type = this.Form.get('DataType')?.value;
    this.DataTypeClass = this.DataTypeMap.get(type.toString());
    var secondType = this.Form.get('SecondDisplayDataType')?.value;
    this.SecondDataTypeClass = this.DataTypeMap.get(secondType.toString());
    this.HalfWidth = this.Form.get('Mode')?.value == 2;
    this.FullPanel = this.Form.get('Mode')?.value == 2;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      (document.querySelector('.modal-background') as HTMLElement).style.opacity = '1';
    }, 1);
  }

  DataTypeChanged(): void {
    var type = this.Form.get('DataType')?.value;
    this.DataTypeClass = this.DataTypeMap.get(type.toString());
  }

  SecondDataTypeChanged(): void {
    var secondType = this.Form.get('SecondDisplayDataType')?.value;
    this.SecondDataTypeClass = this.DataTypeMap.get(secondType);
  }

  ModeChanged() : void {
    if (this.Form.get('Mode')?.value == 1) {
      this.HalfWidth = false;
      this.FullPanel = false;
    } else {
      this.HalfWidth = true;
      this.FullPanel = true;
    }
  }

  toggleConditionGroup(): void {
    this.isConditionGroupMinimized = !this.isConditionGroupMinimized;
  }
}
